"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertCard = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Flag_1 = require("@opsbase/lib-issue/Flag");
const IssueStatus_1 = require("@opsbase/lib-issue/IssueStatus");
const opIs_1 = __importDefault(require("@opsbase/lib-op/helpers/opIs"));
const OpStatus_1 = require("@opsbase/lib-op/OpStatus");
const lib_pages_1 = __importDefault(require("@opsbase/lib-pages"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const utils_1 = require("@opsbase/lib-time/utils");
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const LinkCard_1 = __importDefault(require("@opsbase/web-cards/LinkCard"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const IssueIcon_1 = __importDefault(require("@opsbase/web-icons/icons/IssueIcon"));
const RosetteIcon_1 = __importDefault(require("@opsbase/web-icons/icons/RosetteIcon"));
const TickIcon_1 = __importDefault(require("@opsbase/web-icons/icons/TickIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    root: {
        borderBottom: `1px solid ${lib_palette_1.default.WhiteSmoke.main}`,
        marginBottom: 16,
    },
    title: {
        color: lib_palette_1.default.GreyBlue.main,
    },
    sentDate: {
        fontSize: 12,
        lineHeight: '14px',
        color: lib_palette_1.default.GreyBlue.main,
    },
});
function AlertCard(props) {
    const { classes, alert, read, onMarkAsRead, onMarkAsUnread } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [], classes);
    const { goTo } = (0, useNav_1.default)();
    const { settings } = (0, useSelf_1.default)();
    const handleClickRelated = (0, useCallforward_1.default)((type, item) => () => {
        if (type === DataType_1.default.ISSUE)
            goTo(lib_pages_1.default.ISSUES_VIEW, { id: item.id });
        if (type === DataType_1.default.OP) {
            return goTo(opIs_1.default.performable(item) ? lib_pages_1.default.OP_PERFORM : lib_pages_1.default.OP_VIEW, {
                id: item.id,
            });
        }
    }, [goTo]);
    return (0, react_1.useMemo)(() => {
        const title = alert === null || alert === void 0 ? void 0 : alert.title;
        const sentDate = (0, utils_1.logStamp)(alert === null || alert === void 0 ? void 0 : alert.sentDate, '');
        const relatedIssue = alert === null || alert === void 0 ? void 0 : alert.relatedIssue;
        const relatedOp = alert === null || alert === void 0 ? void 0 : alert.relatedOp;
        return (react_1.default.createElement(Vertical_1.default, { shrink: true, padding: true, classes: { root: myCss.root } },
            react_1.default.createElement(Text_1.default, { className: myCss.title }, title),
            !!relatedIssue && (react_1.default.createElement(LinkCard_1.default, { tags: [settings.getIssueTypeTitle(relatedIssue === null || relatedIssue === void 0 ? void 0 : relatedIssue.type)], watermark: IssueIcon_1.default, watermarkColor: (0, Flag_1.flagColor)(relatedIssue === null || relatedIssue === void 0 ? void 0 : relatedIssue.flag), title: relatedIssue === null || relatedIssue === void 0 ? void 0 : relatedIssue.title, statusColor: (0, IssueStatus_1.issueStatusColor)(relatedIssue === null || relatedIssue === void 0 ? void 0 : relatedIssue.status), onClick: handleClickRelated(DataType_1.default.ISSUE, relatedIssue) })),
            !!relatedOp && (react_1.default.createElement(LinkCard_1.default, { tags: [settings === null || settings === void 0 ? void 0 : settings.getOpTypeTitle(relatedOp === null || relatedOp === void 0 ? void 0 : relatedOp.type)], watermark: relatedOp.isScoreEnabled ? RosetteIcon_1.default : TickIcon_1.default, title: relatedOp === null || relatedOp === void 0 ? void 0 : relatedOp.title, statusColor: (0, OpStatus_1.opStatusColor)(relatedOp === null || relatedOp === void 0 ? void 0 : relatedOp.status), onClick: handleClickRelated(DataType_1.default.OP, relatedOp) })),
            react_1.default.createElement(Horizontal_1.default, { alignItems: "flex-end" },
                react_1.default.createElement(Text_1.default, { className: myCss.sentDate }, sentDate),
                !read && (react_1.default.createElement(Button_1.default, { small: true, background: 'transparent', color: lib_palette_1.default.secondary, label: lib_i18n_1.default.t('mark-read'), onClick: onMarkAsRead })),
                read && (react_1.default.createElement(Button_1.default, { small: true, background: 'transparent', color: lib_palette_1.default.GreyBlue, label: lib_i18n_1.default.t('mark-unread'), onClick: onMarkAsUnread })))));
    }, [alert, myCss, settings, handleClickRelated, read, onMarkAsRead, onMarkAsUnread]);
}
exports.AlertCard = AlertCard;
exports.default = AlertCard;
